module.exports = __webpack_public_path__ + "531d713de6de9a0f546656a427f4dd96.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dev_prev.png
// module id = 153
// module chunks = 0